(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["brand-story"] && !Shopify.designMode) return;
  try {
    
const brandStoryImg = document.getElementById("brand-story-image");
const fadeupElements = document.querySelectorAll(".brand-story-fadeup");

const callback = (entries, observer) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.remove("opacity-0", "translate-y-6");
      observer.unobserve(entry.target);
    }
  });
};

const options = {
  root: null,
  rootMargin: '-100px',
  threshold: 0.2
};

const observer = new IntersectionObserver(callback, options);

if (brandStoryImg) {
  observer.observe(brandStoryImg);
}

fadeupElements.forEach(el => {
  observer.observe(el);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart-drawer"]) return;
  try {
    
  // Cart drawer controller.
  //
  // The drawer section is rendered on every page (footer section group), so this
  // block is bundled once into the theme's section JS and runs a single time.
  // All listeners are delegated on `document`, so they keep working after the
  // drawer body is re-rendered from the Section Rendering API.
  (function () {
    if (window.__cartDrawerInit) return;
    window.__cartDrawerInit = true;

    var root = document.documentElement;

    function getDrawer() { return document.querySelector('[data-cart-drawer]'); }
    function getBody() { return document.querySelector('[data-cart-drawer-body]'); }

    function openDrawer() {
      root.setAttribute('data-cart-open', '');
      document.body.style.overflow = 'hidden';
      var drawer = getDrawer();
      if (drawer) drawer.focus();
    }

    function closeDrawer() {
      root.removeAttribute('data-cart-open');
      document.body.style.overflow = '';
    }

    function setLoading(state) {
      var drawer = getDrawer();
      if (drawer) drawer.classList.toggle('is-loading', state);
    }

    function updateCount(count) {
      document.querySelectorAll('[data-cart-count]').forEach(function (el) {
        el.textContent = count;
        if (count > 0) {
          el.removeAttribute('hidden');
        } else {
          el.setAttribute('hidden', '');
        }
      });
    }

    // Swap the drawer body with freshly rendered section HTML and sync the
    // header badge from the server-rendered item count.
    function applySectionHTML(html) {
      var body = getBody();
      if (!body || !html) return;
      var parsed = new DOMParser().parseFromString(html, 'text/html');
      var newBody = parsed.querySelector('[data-cart-drawer-body]');
      if (!newBody) return;
      body.innerHTML = newBody.innerHTML;
      var countEl = body.querySelector('[data-cart-item-count]');
      updateCount(countEl ? (parseInt(countEl.textContent, 10) || 0) : 0);
    }

    // Prefer the sections returned inline by the cart API; otherwise fetch.
    function refresh(sections) {
      if (sections && sections['cart-drawer']) {
        applySectionHTML(sections['cart-drawer']);
        return Promise.resolve();
      }
      return fetch('/?sections=cart-drawer')
        .then(function (r) { return r.json(); })
        .then(function (data) { applySectionHTML(data['cart-drawer']); });
    }

    // ---- Add to cart (product page + collection cards) ----
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();

      var button = form.querySelector('[type="submit"]');
      if (button) button.setAttribute('disabled', '');

      var formData = new FormData(form);
      formData.append('sections', 'cart-drawer');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok, data: data };
          });
        })
        .then(function (result) {
          if (button) button.removeAttribute('disabled');
          if (!result.ok) {
            window.alert((result.data && result.data.description) || 'Could not add to cart.');
            return;
          }
          openDrawer();
          return refresh(result.data.sections);
        })
        .catch(function () {
          if (button) button.removeAttribute('disabled');
        });
    });

    // ---- Close, quantity change, remove ----
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-cart-close]') || event.target.closest('[data-cart-overlay]')) {
        closeDrawer();
        return;
      }

      var changeBtn = event.target.closest('[data-cart-change]');
      if (!changeBtn) return;
      event.preventDefault();

      var line = changeBtn.getAttribute('data-line');
      var qty = changeBtn.getAttribute('data-qty');
      if (line === null || qty === null) return;

      setLoading(true);
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          line: parseInt(line, 10),
          quantity: parseInt(qty, 10),
          sections: 'cart-drawer'
        })
      })
        .then(function (response) { return response.json(); })
        .then(function (data) {
          setLoading(false);
          return refresh(data.sections);
        })
        .catch(function () { setLoading(false); });
    });

    // ---- Cart note (debounced) ----
    var noteTimer;
    document.addEventListener('input', function (event) {
      var note = event.target.closest('[data-cart-note]');
      if (!note) return;
      clearTimeout(noteTimer);
      noteTimer = setTimeout(function () {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ note: note.value })
        });
      }, 500);
    });

    // ---- Escape closes the drawer ----
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  // Cart page +/- steppers: adjust the number input only; the customer presses
  // "Update Cart" to persist. Delegated so it works regardless of row count.
  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-qty-minus], [data-qty-plus]');
    if (!btn) return;

    var stepper = btn.closest('[data-qty-stepper]');
    if (!stepper || stepper.closest('[data-cart-drawer]')) return; // drawer steppers are AJAX

    var input = stepper.querySelector('[data-qty-input]');
    if (!input) return;

    var value = parseInt(input.value, 10);
    if (isNaN(value)) value = 0;

    if (btn.hasAttribute('data-qty-plus')) {
      value += 1;
    } else {
      value = Math.max(0, value - 1);
    }

    input.value = value;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  // Client-side tag filtering with animations for animate-css-grid
  const filterTags = document.querySelectorAll('.filter-tag');
  const productCards = document.querySelectorAll('.product-card');

  // At lg+ the sidebar occupies cols 1-4 of row 1 and products span 3 cols, so column 1
  // must stay empty on rows 2+ (every new row starts at col 2). This replicates the intent
  // of the old [&:nth-child(3n+1)]:col-start-2 rule, but keyed off the *visible* cards so it
  // stays correct after filtering hides products (CSS :nth-child can't track visibility).
  const lgQuery = window.matchMedia('(min-width: 1024px)');

  function applyProductOffset() {
    const visible = [...productCards].filter(card => !card.classList.contains('hidden'));
    visible.forEach((card, i) => {
      // Row 1 holds 2 products beside the sidebar; every 3rd visible card starts a new row.
      const isRowLeader = i >= 2 && (i - 2) % 3 === 0;
      card.style.gridColumnStart = lgQuery.matches && isRowLeader ? '2' : '';
    });
  }

  applyProductOffset();
  lgQuery.addEventListener('change', applyProductOffset);

  filterTags.forEach(filter => {
    filter.addEventListener('click', () => {
      // Check if this filter was already active
      const isActive = filter.classList.contains('active-filter');
      
      // Clear active state from ALL filters
      filterTags.forEach(f => f.classList.remove('active-filter'));
      
      if (!isActive) {
        // ACTIVATE: mark this filter, then show/hide products
        filter.classList.add('active-filter');
        const selectedTag = filter.getAttribute('data-tag');
        
        productCards.forEach(card => {
          if (card.classList.contains(selectedTag)) {
            // Show matching card with animation
            card.classList.remove('hidden');
            card.classList.add('block');
            requestAnimationFrame(() => {
              card.classList.remove('opacity-0', 'scale-95');
              card.classList.add('opacity-100', 'scale-100');
            });
          } else {
            // Hide non-matching card with animation
            card.classList.remove('opacity-100', 'scale-100');
            card.classList.add('opacity-0', 'scale-95');
            setTimeout(() => {
              card.classList.remove('block');
              card.classList.add('hidden');
            }, 200);
          }
        });
        // Recompute the col-2 offset once the hidden cards have left the grid.
        setTimeout(applyProductOffset, 220);
      } else {
        // DEACTIVATE (toggle off): show all products with animation
        productCards.forEach(card => {
          card.classList.remove('hidden');
          card.classList.add('block');
          requestAnimationFrame(() => {
            card.classList.remove('opacity-0', 'scale-95');
            card.classList.add('opacity-100', 'scale-100');
          });
        });
        // Cards are visible again immediately; realign now.
        applyProductOffset();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
(function() {
  function loadMicroModal() {
    var el = document.getElementById('micromodal-src');
    if (!el) return;
    var script = document.createElement('script');
    script.src = el.dataset.src;
    script.onload = function() {
      MicroModal.init({
        disableScroll: true,
        awaitCloseAnimation: true,
        onShow: function() {
          document.getElementById('hamburger').setAttribute('aria-expanded', 'true');
        },
        onClose: function() {
          document.getElementById('hamburger').setAttribute('aria-expanded', 'false');
        }
      });
    };
    document.head.appendChild(script);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', loadMicroModal);
  } else {
    loadMicroModal();
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
// Hero image fade-in
const heroImg = document.getElementById("hero-image");
const heroFadeupElements = document.querySelectorAll(".hero-fadeup");

function handleLoading(heroImg) {
  const handleLoad = () => {
    heroImg.classList.add("fadein");
    
    // Trigger text fade-in-up after image fade starts (300ms delay)
    setTimeout(() => {
      heroFadeupElements.forEach(el => {
        el.classList.remove("opacity-0", "translate-y-6");
      });
    }, 300);
  };
  
  if (heroImg.complete) {
    handleLoad();
  } else {
    heroImg.onload = handleLoad;
  }
}

handleLoading(heroImg);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-hero"] && !Shopify.designMode) return;
  try {
    
const pageHeroImg = document.getElementById("page-hero-image");
const pageHeroFadeupElements = document.querySelectorAll(".page-hero-fadeup");

function handlePageHeroLoading(img) {
  const handleLoad = () => {
    img.classList.add("fadein");
    setTimeout(() => {
      pageHeroFadeupElements.forEach(el => {
        el.classList.remove("opacity-0", "translate-y-6");
      });
    }, 300);
  };

  if (img.complete) {
    handleLoad();
  } else {
    img.onload = handleLoad;
  }
}

if (pageHeroImg) {
  handlePageHeroLoading(pageHeroImg);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var el = document.querySelector('#product-gallery');
  if (!el) return;
  var multiple = el.querySelectorAll('.splide__slide').length > 1;
  new Splide('#product-gallery', {
    type: multiple ? 'loop' : 'slide',
    perPage: 1,
    perMove: 1,
    arrows: multiple,
    pagination: false,
    drag: multiple,
    speed: 500,
  }).mount();
});

  } catch(e) { console.error(e); }
})();
})();
